<div class="banner-bg">
  <div class="banner-container">
    <nav aria-label="Breadcrumb">
      <ol class="breadcrumbs">
        <li>
          <a href="/">Home</a>
        </li>
        <li>Contact Us</li>
      </ol>
    </nav>

    <div class="title-wrapper">
      <h2>Contact Us</h2>
    </div>

    <p class="banner-description">
      Have questions or need assistance? We're here to help! Reach out to us
      through any of the following channels or fill out the form below.
    </p>
  </div>
</div>

<div class="container mx-auto px-4 py-12">
  <div class="max-w-5xl mx-auto">
    <div class="grid md:grid-cols-2 gap-8">
      <!-- Contact Information -->
      <div class="space-y-6">
        <div
          class="daisy-card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow duration-300"
        >
          <div class="daisy-card-body">
            <h2 class="daisy-card-title text-2xl mb-6 text-primary">
              Get in Touch
            </h2>

            <div class="space-y-6">
              <div class="flex items-start space-x-4 group">
                <div
                  class="p-3 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 text-primary"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-lg mb-1">Email</h3>
                  <p
                    class="text-gray-600 hover:text-primary transition-colors duration-300"
                  >
                    <a href="mailto:support&#64;learnbird.lk"
                      >support&#64;learnbird.lk</a
                    >
                  </p>
                </div>
              </div>

              <div class="flex items-start space-x-4 group">
                <div
                  class="p-3 bg-primary/10 rounded-lg group-hover:bg-primary/20 transition-colors duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 text-primary"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-lg mb-1">Phone or Whatsapp</h3>
                  <p
                    class="text-gray-600 hover:text-primary transition-colors duration-300"
                  >
                    <a href="tel:+94785725494">+94 78 572 5494</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact Form -->
      <div
        class="daisy-card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow duration-300"
      >
        <div class="daisy-card-body">
          <h2 class="daisy-card-title text-2xl mb-6 text-primary">
            Send us a Message
          </h2>
          <form
            [formGroup]="contactForm"
            (ngSubmit)="onSubmit()"
            class="space-y-4"
          >
            <fieldset class="daisy-fieldset">
              <legend class="daisy-label-text font-medium">Name</legend>
              <input
                type="text"
                formControlName="name"
                class="daisy-input daisy-input-bordered w-full"
                placeholder="Your name"
                required
              />
            </fieldset>

            <fieldset class="daisy-fieldset">
              <legend class="daisy-label-text font-medium">Email</legend>
              <input
                type="email"
                formControlName="email"
                class="daisy-input daisy-input-bordered w-full"
                placeholder="your.email@example.com"
                required
              />
            </fieldset>

            <fieldset class="daisy-fieldset">
              <legend class="daisy-fieldset-legend font-medium">Subject</legend>
              <input
                type="text"
                formControlName="subject"
                class="daisy-input daisy-input-bordered w-full"
                placeholder="Message subject"
                required
              />
            </fieldset>

            <fieldset class="daisy-fieldset">
              <legend class="daisy-label-text font-medium">Message</legend>
              <textarea
                formControlName="message"
                class="daisy-textarea daisy-textarea-bordered focus:daisy-textarea-primary h-32 w-full"
                placeholder="Your message"
                required
              ></textarea>
            </fieldset>

            <div class="form-control mt-6">
              <button
                type="submit"
                class="daisy-btn daisy-btn-primary w-full"
                [disabled]="!contactForm.valid || isSubmitting"
              >
                @if (isSubmitting) {
                <span class="loading loading-spinner"></span>
                }
                {{ isSubmitting ? 'Sending...' : 'Send Message' }}
              </button>
            </div>

            <!-- Success Message -->
            @if (submitSuccess) {
            <div class="mt-4 p-4 bg-success/10 text-success rounded-lg">
              <p>Thank you for your message! We'll get back to you soon.</p>
            </div>
            }

            <!-- Error Message -->
            @if (submitError) {
            <div class="mt-4 p-4 bg-error/10 text-error rounded-lg">
              <p>
                Sorry, there was an error sending your message. Please try again
                later.
              </p>
            </div>
            }
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
